import { Header as HeaderBase } from 'shared';
import styled, { to } from 'theme';

export const Header = styled(HeaderBase)`
  .header__nav-toggle {
    > span {
      display: none;
    }
  }

  .header__logo {
    visibility: visible;
    left: 0.5rem;
    top: 0.75rem;
  }
`;

export const HeaderTitle = styled.div`
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  font-size: ${props => props.theme.variables.fonts.size.bigger1};
  font-weight: ${props => props.theme.variables.fonts.weight.bold};
  border-left: 0.0625rem solid ${props => props.theme.variables.customColors.lightGreyText};
  color: ${props => props.theme.variables.customColors.textColor};
  height: 3.75rem;
  display: flex;
  align-items: center;
  margin: -0.5rem 2rem -0.5rem 2rem;
  padding-left: 2rem;

  ${to('lg')} {
    display: none;
  }
`;
